import { IPrice } from '../IPrice';

export function assertSameCurrency(a: IPrice, b: IPrice) {
	if (a.currencyCode !== b.currencyCode) {
		throw new Error('Currency mismatch');
	}
}
